/**
 * User Type Mapper
 * 
 * Maps Strapi CustomerTypeDisplay strings to WordPress customer type codes
 * Preserves the 9 user type visibility logic from WordPress header system
 */

export const STRAPI_TO_WP_USER_TYPE: Record<string, string> = {
  "User Type 1 (Not Logged In)": "not-logged-in",
  "User Type 2 (Logged In but not Binded)": "not-binded",
  "User Type 3 (VIM - Logged In & Binded but Cannot Upgrade)": "001",
  "User Type 4 (Combo / Pack - Logged In & Binded and can Upgrade)": "005",
  "User Type 5 (Pack/PCD - Logged In & Binded and can Upgrade)": "004",
  "User Type 6 (Starter Pack / Free Channels)": "003",
  "User Type 7 (Lamma Island - Logged In & Binded but Cannot Upgrade)": "002",
  "User Type 8 (Now OTT - Logged In & Binded)": "ott"
};

/**
 * Convert Strapi CustomerTypeDisplay array to WordPress customer type codes
 * 
 * @param customerTypeDisplay - Array of Strapi customer type strings
 * @returns Array of WordPress customer type codes
 * 
 * @example
 * convertCustomerTypeDisplay([
 *   "User Type 1 (Not Logged In)",
 *   "User Type 8 (Now OTT - Logged In & Binded)"
 * ])
 * // Returns: ["not-logged-in", "ott"]
 */
export function convertCustomerTypeDisplay(customerTypeDisplay: string[]): string[] {
  if (!customerTypeDisplay || customerTypeDisplay.length === 0) {
    return ['all'];
  }

  return customerTypeDisplay
    .map(displayType => STRAPI_TO_WP_USER_TYPE[displayType] || displayType)
    .filter(Boolean);
}

/**
 * Get normalized customer type for visibility checks
 * Handles special cases like r2stb -> 001 and 000 -> 002
 * 
 * @param custType - Current user's customer type
 * @returns Normalized customer type for comparison
 */
export function normalizeCustomerType(custType: string): string {
  // Special case: R2STB users see 001 items
  if (custType === 'r2stb') {
    return '001';
  }
  
  // Special case: 000 treated as 002
  if (custType === '000') {
    return '002';
  }
  
  return custType;
}
